export default __webpack_public_path__ + "static/media/Stamp2.700f5ef5.svg";